

// // export default ProgramsOverview;
// import React, { useEffect, useState } from 'react';
// import data from '../../programs.json';
// import { useNavigate } from 'react-router-dom';
// import ProgramEnrollment from './ProgramEnrollment';

// const { programsOverview } = data;

// const ProgramsOverview = () => {

//   const { id, heading } = programsOverview;
//   const [programs, setPrograms] = useState([]);
//   const CLINIC_ID = `6a3ba96dc8e05c65af7f0ef0`;
//   const navigate = useNavigate();
//   const [enrollModalOpen, setEnrollModalOpen] = useState(false);
//   const [selectedProgram, setSelectedProgram] = useState(null);

//   const handleEnrollNow = (program) => {
//     setSelectedProgram(program);
//     setEnrollModalOpen(true);
//   };

//   const handleContinueFromDetails = (program) => {
//     // Step 2 (consent) goes here next
//     console.log("continue clicked, program:", program);
//   };
//   useEffect(() => {
//     const fetchPrograms = async () => {
//       try {
//         const res = await fetch(`https://api.avexa.net/clinic-onboarding/clinics/${CLINIC_ID}/programs`);
//         const data = await res.json();
//         setPrograms(data);
//       } catch (error) {
//         console.log(error, "error fetching programs");
//       }
//     };
//     fetchPrograms();
//   }, []);

//   return (
//     <section id={id} className="w-full bg-white pt-10 md:pt-14 ">
//       <div className="container mx-auto px-8 md:px-14">

//         <h2 className="mb-8 md:mb-10 ava-heading-md">
//           {heading}
//         </h2>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
//           {programs.map((program, index) => (
//             <ProgramCard key={program.id} program={program}
//               enableViewProgram={index === 0}
//               onEnrollNow={() => handleEnrollNow(program)}
//             />
//           ))}
//         </div>
//         <ProgramEnrollment
//           program={selectedProgram}
//           isOpen={enrollModalOpen}
//           onClose={() => setEnrollModalOpen(false)}
//           onContinue={handleContinueFromDetails}
//         />
//       </div>
//     </section>
//   );
// };

// /* ── Program icon — uses iconUrl or falls back to a generic SVG ── */
// const ProgramIcon = ({ iconUrl, programCode }) => {
//   if (iconUrl) {
//     return (
//       <img
//         src={iconUrl}
//         alt=""
//         style={{ width: 48, height: 48, objectFit: "contain" }}
//       />
//     );
//   }

//   // colour per program type
//   const colors = {
//     PCOS: { bg: "#e0f7f4", stroke: "#0D9488" },
//     PREGNANCY_CARE: { bg: "#fce4ec", stroke: "#e91e8c" },
//     POSTNATAL_CARE: { bg: "#fff3e0", stroke: "#f57c00" },
//     GENERAL_WELLNESS: { bg: "#e8eaf6", stroke: "#5c6bc0" },
//   };
//   const { bg, stroke } = colors[programCode] ?? { bg: "#f3f4f6", stroke: "#6b7280" };

//   return (
//     <div style={{
//       width: 56, height: 56,
//       borderRadius: 14,
//       background: bg,
//       display: "flex", alignItems: "center", justifyContent: "center",
//       flexShrink: 0,
//     }}>
//       <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
//         stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M12 2C8.13 2 5 5.13 5 9c0 2.5 1.3 4.7 3.3 6l.7 5h6l.7-5C17.7 13.7 19 11.5 19 9c0-3.87-3.13-7-7-7z" />
//         <path d="M9 17h6" />
//       </svg>
//     </div>
//   );
// };

// export default ProgramsOverview;
import React, { useEffect, useMemo, useState } from 'react';
import data from '../../programs.json';
import { useNavigate } from 'react-router-dom';
import ProgramEnrollment from './ProgramEnrollment';

const { programsOverview } = data;
export const ProgramCard = ({ program, onViewProgram,
  onCheckEligibility, enableViewProgram, onEnrollNow }) => {
  const {
    programName,
    programCode,
    description,
    durationValue,
    durationUnit,
    consultationModes = [],
    conditionFocuses = [],
    lifeStages = [],
    services = [],
    price,
    iconUrl,
  } = program;
  const navigate = useNavigate();

  // care team: pull from services → serviceType or serviceName
  const careTeam = services
    .map((s) => s.serviceName ?? s.serviceType)
    .filter(Boolean)
    .slice(0, 3);
  const handleViewProgram = () => {
    navigate(`/programs/${programCode}`);
  };

  // const handleCheckEligibility = () => {
  //   // navigate(`/programs/${programCode}/eligibility`);
  //   navigate('/findprogram');
  // };
  // const handleCheckEligibility = (item) => {
  //   const code = item.programCode ?? item.id;
  //   console.log(item, "thi sis the itmemmmm")
  // };
  const handleCheckEligibility = () => {
    navigate(`/findprogram?programCode=${encodeURIComponent(programCode)}&screen=eligibility`);
  };

  // mode: first consultationMode name
  // const mode = consultationModes[0]?.name ?? consultationModes[0]?.modeName ?? "Hybrid";
  const mode = consultationModes.map((c) => c.name ?? c.name).filter(Boolean).join(", ") || "Hybrid";

  // highlights: conditionFocuses + lifeStages labels
  const highlights = [
    ...conditionFocuses.map((c) => c.name ?? c.conditionName),
    ...lifeStages.map((l) => l.name ?? l.stageName),
  ].filter(Boolean).slice(0, 4);

  // duration label
  const durationLabel = durationValue
    ? `${durationValue} ${durationValue === 1 ? "day" : "days"}`
    : null;

  return (
    // NOTE: parent grid/flex container should use `alignItems: "stretch"`
    // so every card in a row gets the same height to fill.
    <div style={{
      background: "#fff",
      borderRadius: 20,
      border: "1px solid #f0f0f0",
      boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
      display: "flex",
      flexDirection: "column",
      padding: "20px 20px 16px",
      gap: 14,
      position: "relative",
      height: "100%",       // ← fill the grid cell / row height
    }}>

      {/* ── Wishlist icon (top right) ── */}
      {/* <button style={{
        position: "absolute", top: 16, right: 16,
        background: "none", border: "none", cursor: "pointer", padding: 0,
      }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      </button> */}

      {/* ── TOP: icon + name + description ── */}
      <div style={{ display: "flex", gap: 14, alignItems: "flex-start", paddingRight: 28 }}>
        <ProgramIcon iconUrl={iconUrl} programCode={programCode} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontSize: 15, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>
            {programName}
          </p>
          <p style={{ fontSize: 12, color: "#777", margin: "4px 0 0", lineHeight: 1.5 }}>
            {description}
          </p>
        </div>
      </div>

      {/* ── DIVIDER ── */}
      <div style={{ height: 1, background: "#f3f3f3" }} />

      {/* ── META ROW: duration | care team | mode ── */}
      <div style={{ display: "flex", gap: 8 }}>

        {/* Duration */}
        {durationLabel && (
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 3 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
              </svg>
              <span style={{ fontSize: 10, color: "#aaa", fontWeight: 500 }}>Duration</span>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{durationLabel}</span>
          </div>
        )}
        {price != null && (
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 3 }}>
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#888"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M8 9h6a2 2 0 010 4H10a2 2 0 000 4h6" />
              </svg>
              <span style={{ fontSize: 10, color: "#aaa", fontWeight: 500 }}>Price</span>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>
              ₹{price.toLocaleString("en-IN")}
            </span>
          </div>
        )}
        {/* Care Team */}
        {careTeam.length > 0 && (
          <div style={{ flex: 2, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 3 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <span style={{ fontSize: 10, color: "#aaa", fontWeight: 500 }}>Speciality Name</span>
            </div>
            <span style={{ fontSize: 12, color: "#1a1a2e", lineHeight: 1.4 }}>
              {careTeam.join(", ")}
            </span>
          </div>
        )}

        {/* Mode */}

      </div>
      {mode && (
        <div style={{
          display: "flex", alignItems: "center",
          gap: "6px", minWidth: 0
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            {/* <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="16" height="12" rx="2" />
                <polyline points="22 8 16 12 16 16 22 16 22 8" />
              </svg> */}
            {/* <span style={{ fontSize: 10, color: "#aaa", fontWeight: 500 }}>Mode</span> */}
            <span style={{ fontSize: 11, fontWeight: 700, color: "#555" }}>Mode:</span>

          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#1a1a2e" }}>{mode}</span>
        </div>
      )}
      {/* ── HIGHLIGHTS ── */}
      {highlights.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#555" }}>Highlights:</span>
          {highlights.map((h, i) => (
            <React.Fragment key={h}>
              <span style={{ fontSize: 11, color: "#777" }}>{h}</span>
              {i < highlights.length - 1 && (
                <span style={{ color: "#ccc", fontSize: 11 }}>•</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}

      {/* ── SPACER + DIVIDER + BUTTONS, pinned to bottom ── */}
      <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ height: 1, background: "#f3f3f3" }} />

        <div style={{ display: "flex", gap: 10, justifyContent: "space-between" }}>
          <button
            className='btn-transparent'
            // onClick={handleViewProgram}
            // style={{
            //   pointerEvents: enableViewProgram ? "auto" : "none",
            //   opacity: enableViewProgram ? 1 : 0.5,
            //   cursor: enableViewProgram ? "pointer" : "default",
            // }}
            onClick={onViewProgram ?? handleViewProgram}
          >
            View Program
          </button>
          <button
            className='btn-primary'
            onClick={() => onEnrollNow?.(program)}
          // onClick={handleCheckEligibility}
          // onClick={onCheckEligibility ?? handleCheckEligibility}
          >
            Enroll Now
          </button>
        </div>
      </div>

    </div>
  );
};


const ProgramsOverview = () => {
  const { id, heading } = programsOverview;
  const [programs, setPrograms] = useState([]);
  const CLINIC_ID = `6a3ba96dc8e05c65af7f0ef0`;
  const navigate = useNavigate();
  const [enrollModalOpen, setEnrollModalOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);

  // ── Filter state ──────────────────────────────────────────
  const [search, setSearch] = useState("");
  const [filterLifeStage, setFilterLifeStage] = useState([]); // array of lifeStage ids
  const [filterMode, setFilterMode] = useState([]);           // array of consultationMode names

  const handleEnrollNow = (program) => {
    setSelectedProgram(program);
    setEnrollModalOpen(true);
  };

  const handleContinueFromDetails = (program) => {
    console.log("continue clicked, program:", program);
  };

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await fetch(`https://api.avexa.net/clinic-onboarding/clinics/${CLINIC_ID}/programs`);
        const data = await res.json();
        setPrograms(Array.isArray(data) ? data : data.programs ?? []);
      } catch (error) {
        console.log(error, "error fetching programs");
      }
    };
    fetchPrograms();
  }, []);

  // ── Derive filter options straight from the fetched programs ──
  const lifeStageOptions = useMemo(() => {
    const seen = new Map();
    programs.forEach((p) =>
      (p.lifeStages || []).forEach((ls) => {
        if (ls?.id && !seen.has(ls.id)) seen.set(ls.id, ls.name ?? ls.id);
      })
    );
    return [...seen.entries()].map(([value, label]) => ({ value, label }));
  }, [programs]);

  const modeOptions = useMemo(() => {
    const seen = new Set();
    programs.forEach((p) =>
      (p.consultationModes || []).forEach((m) => {
        const name = m?.name;
        if (name) seen.add(name);
      })
    );
    return [...seen].map((v) => ({ value: v, label: v }));
  }, [programs]);

  const toggleLifeStage = (v) =>
    setFilterLifeStage((prev) => (prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v]));

  const toggleMode = (v) =>
    setFilterMode((prev) => (prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v]));

  const clearFilters = () => {
    setSearch("");
    setFilterLifeStage([]);
    setFilterMode([]);
  };

  const hasActiveFilters = search || filterLifeStage.length > 0 || filterMode.length > 0;

  // ── Filtered result set ──────────────────────────────────
  const filteredPrograms = useMemo(() => {
    return programs.filter((p) => {
      const nameMatch =
        !search ||
        p.programName?.toLowerCase().includes(search.toLowerCase()) ||
        p.description?.toLowerCase().includes(search.toLowerCase());

      const lsIds = (p.lifeStages || []).map((ls) => ls.id);
      const lsMatch = filterLifeStage.length === 0 || filterLifeStage.some((id) => lsIds.includes(id));

      const modeNames = (p.consultationModes || []).map((m) => m.name);
      const modeMatch = filterMode.length === 0 || filterMode.some((m) => modeNames.includes(m));

      return nameMatch && lsMatch && modeMatch;
    });
  }, [programs, search, filterLifeStage, filterMode]);

  return (
    <section id={id} className="w-full bg-white pt-10 md:pt-14">
      <div className="container mx-auto px-8 md:px-14">

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <h2 className="ava-heading-md">{heading}</h2>

          {/* Search */}
          <div className="relative w-full md:w-72">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search programs..."
              className="w-full text-sm rounded-full border border-gray-200 pl-10 pr-4 py-2.5 outline-none focus:border-gray-400 transition-colors"
            />
            <svg
              width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)" }}
            >
              <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6">

          {/* ── Filter sidebar ── */}
          {(lifeStageOptions.length > 0 || modeOptions.length > 0) && (
            <div className="lg:sticky lg:top-6 lg:self-start rounded-2xl border border-gray-100 p-4" style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.05)" }}>
              {lifeStageOptions.length > 0 && (
                <FilterGroup
                  title="Life Stage"
                  opts={lifeStageOptions}
                  selected={filterLifeStage}
                  toggle={toggleLifeStage}
                />
              )}
              {modeOptions.length > 0 && (
                <FilterGroup
                  title="Consultation Mode"
                  opts={modeOptions}
                  selected={filterMode}
                  toggle={toggleMode}
                />
              )}
              {hasActiveFilters && (
                <button
                  onClick={clearFilters}
                  className="text-xs font-semibold text-gray-500 hover:text-gray-700 mt-1"
                >
                  🔄 Clear filters
                </button>
              )}
            </div>
          )}

          {/* ── Result grid ── */}
          <div>
            <p className="text-sm text-gray-500 mb-4">
              <strong className="text-gray-800">{filteredPrograms.length}</strong> program
              {filteredPrograms.length !== 1 ? "s" : ""} found
            </p>

            {filteredPrograms.length === 0 ? (
              <div className="rounded-2xl border border-gray-100 text-center py-16 px-6">
                <div className="text-4xl mb-3">🔍</div>
                <p className="font-semibold text-gray-800 mb-1">No programs found</p>
                <p className="text-sm text-gray-500 mb-4">Try adjusting your filters or search terms</p>
                <button onClick={clearFilters} className="btn-primary">Clear all filters</button>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-2 gap-5 md:gap-6" style={{ alignItems: "stretch" }}>
                {filteredPrograms.map((program, index) => (
                  <ProgramCard
                    key={program.id}
                    program={program}
                    enableViewProgram={index === 0}
                    onEnrollNow={() => handleEnrollNow(program)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        <ProgramEnrollment
          program={selectedProgram}
          isOpen={enrollModalOpen}
          onClose={() => setEnrollModalOpen(false)}
          onContinue={handleContinueFromDetails}
        />
      </div>
    </section>
  );
};

/* ── Reusable checkbox filter group ── */
const FilterGroup = ({ title, opts, selected, toggle }) => (
  <div className="mb-5">
    <p className="text-xs font-bold text-gray-700 mb-2.5">{title}</p>
    <div className="flex flex-col gap-2">
      {opts.map((o) => {
        const isChecked = selected.includes(o.value);
        return (
          <label key={o.value} className="flex items-center gap-2 cursor-pointer select-none">
            <span
              onClick={() => toggle(o.value)}
              style={{
                width: 16, height: 16, borderRadius: 4, flexShrink: 0,
                border: `1.5px solid ${isChecked ? "var(--primary-color, #1a1a2e)" : "#d1d5db"}`,
                background: isChecked ? "var(--primary-color, #1a1a2e)" : "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              {isChecked && <span style={{ color: "#fff", fontSize: 10, lineHeight: 1 }}>✓</span>}
            </span>
            <span
              className="text-xs"
              style={{ color: isChecked ? "var(--primary-color, #1a1a2e)" : "#6b7280", fontWeight: isChecked ? 600 : 400 }}
              onClick={() => toggle(o.value)}
            >
              {o.label}
            </span>
          </label>
        );
      })}
    </div>
  </div>
);

/* ── Program icon — unchanged ── */
const ProgramIcon = ({ iconUrl, programCode }) => {
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        style={{ width: 48, height: 48, objectFit: "contain" }}
      />
    );
  }

  const colors = {
    PCOS: { bg: "#e0f7f4", stroke: "#0D9488" },
    PREGNANCY_CARE: { bg: "#fce4ec", stroke: "#e91e8c" },
    POSTNATAL_CARE: { bg: "#fff3e0", stroke: "#f57c00" },
    GENERAL_WELLNESS: { bg: "#e8eaf6", stroke: "#5c6bc0" },
  };
  const { bg, stroke } = colors[programCode] ?? { bg: "#f3f4f6", stroke: "#6b7280" };

  return (
    <div style={{
      width: 56, height: 56,
      borderRadius: 14,
      background: bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0,
    }}>
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
        stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 2.5 1.3 4.7 3.3 6l.7 5h6l.7-5C17.7 13.7 19 11.5 19 9c0-3.87-3.13-7-7-7z" />
        <path d="M9 17h6" />
      </svg>
    </div>
  );
};

// ── ProgramCard is exactly what you already have — unchanged ──
// export const ProgramCard = ({ program, onViewProgram, onCheckEligibility, enableViewProgram, onEnrollNow }) => {
//   // ... keep your existing ProgramCard implementation exactly as-is
// };

export default ProgramsOverview;